import React from "react";

const InputFilesContext = React.createContext({});

export default InputFilesContext;
